import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import LINKS from '../../../../configs/links';
import Button from '../../../common/base/Button';
import Icon from '../../../common/base/Icon';
import Loading from '../../../common/base/Loading';
import Text from '../../../common/base/Text';
import CopyableField from '../../../common/CopyableField';
import { Div } from '../../../common/helpers/StyledUtils';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
const StyledEmptyView = styled.div`
  flex-grow: 1;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const RequestListEmptyView: React.FC = () => {
  const $ = _c(40);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.webhooks.list({
      limit: 1
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.webhooks) {
    t1 = () => HookdeckAPI.webhooks.list({
      limit: 1
    });
    $[1] = HookdeckAPI.webhooks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: webhooks
  } = useSWR(t0, t1);
  const default_webhook = webhooks && webhooks.count > 0 ? webhooks?.models[0] : null;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = APIMethodKeys.requests.list({
      limit: 1
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.requests) {
    t3 = () => HookdeckAPI.requests.list({
      limit: 1
    });
    $[4] = HookdeckAPI.requests;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: requests
  } = useSWR(t2, t3);
  let t4;
  if ($[6] !== HookdeckAPI.webhooks || $[7] !== addToast || $[8] !== default_webhook?.id) {
    t4 = () => {
      setLoading(true);
      HookdeckAPI.webhooks.test(default_webhook?.id as string).then(() => {
        addToast("info", "Test event sent, hold on a second while it's processed!");
        setLoading(true);
      }).catch(() => setLoading(false));
    };
    $[6] = HookdeckAPI.webhooks;
    $[7] = addToast;
    $[8] = default_webhook?.id;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onSendTestEvent = t4;
  if (!requests || !webhooks) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <StyledEmptyView><Loading /></StyledEmptyView>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  if (default_webhook && requests.count === 0 && location.pathname.includes("/cli")) {
    let t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        all: 7
      };
      t6 = {
        direction: "column",
        align: "center",
        justify: "center"
      };
      $[11] = t5;
      $[12] = t6;
    } else {
      t5 = $[11];
      t6 = $[12];
    }
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Text bold={true} center={true} as="p" size="xl" m={{
        t: 4
      }}>Work with events on your local server</Text>;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const t8 = requests.count === 0 && "Once connected send a request to your Hookdeck URL.";
    let t9;
    if ($[14] !== t8) {
      t9 = <Text as="p" center={true}>Install the CLI to receive your events on your local server while developing or debugging your integration.{" "}{t8}</Text>;
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== default_webhook || $[17] !== requests.count) {
      t10 = requests.count === 0 && <CopyableField value={default_webhook.source.url} />;
      $[16] = default_webhook;
      $[17] = requests.count;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    let t11;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Button as="a" m={{
        y: 6
      }} target="_blank" href={LINKS.product_docs.cli}>Install</Button>;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== t10 || $[21] !== t9) {
      t12 = <StyledEmptyView><Div p={t5} flex={t6}>{t7}{t9}{t10}{t11}</Div></StyledEmptyView>;
      $[20] = t10;
      $[21] = t9;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    return t12;
  }
  if (default_webhook && requests.count === 0) {
    let t5;
    let t6;
    let t7;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        all: 7
      };
      t6 = {
        direction: "column",
        align: "center",
        justify: "center"
      };
      t7 = <Icon icon="loading" muted={true} />;
      $[23] = t5;
      $[24] = t6;
      $[25] = t7;
    } else {
      t5 = $[23];
      t6 = $[24];
      t7 = $[25];
    }
    let t8;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Text bold={true} as="p" size="xl" m={{
        t: 4
      }}>Waiting for a request</Text>;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    let t9;
    if ($[27] !== default_webhook.source.name) {
      t9 = <Text center={true} as="p">Update your source <strong>{default_webhook.source.name}</strong> with the provided Hookdeck url.</Text>;
      $[27] = default_webhook.source.name;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    let t10;
    if ($[29] !== default_webhook.source.url) {
      t10 = <CopyableField mono={true} value={default_webhook.source.url} />;
      $[29] = default_webhook.source.url;
      $[30] = t10;
    } else {
      t10 = $[30];
    }
    let t11;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Text size="s" muted={true} m={{
        y: 4
      }}>– or –</Text>;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    let t12;
    if ($[32] !== loading || $[33] !== onSendTestEvent) {
      t12 = <Button ghost={true} primary={true} disabled={loading} onClick={onSendTestEvent}>Send a test request</Button>;
      $[32] = loading;
      $[33] = onSendTestEvent;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== t10 || $[36] !== t12 || $[37] !== t9) {
      t13 = <StyledEmptyView><Div p={t5} flex={t6}>{t7}{t8}{t9}{t10}{t11}{t12}</Div></StyledEmptyView>;
      $[35] = t10;
      $[36] = t12;
      $[37] = t9;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    return t13;
  }
  let t5;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <StyledEmptyView><Div p={{
        y: 24
      }} flex={{
        direction: "column",
        align: "center",
        justify: "center"
      }}><Text as="p" semi={true} muted={true} m={0}>No requests match those filters...</Text></Div></StyledEmptyView>;
    $[39] = t5;
  } else {
    t5 = $[39];
  }
  return t5;
};
export default RequestListEmptyView;